import { nextTick, ref, watch, type Ref } from 'vue';
import { useUpdateResourceEventMutation } from '/@entities/resourceEvent/api/useResourceEventsQueries';
import type { ResourceEvent } from '/@types/resources';

export function useHighlightToggle(event: Ref<ResourceEvent>) {
  const { mutate } = useUpdateResourceEventMutation();
  const priorityBooking = ref(event.value.isHighlighted ?? false);
  let syncing = false;

  watch(
    () => event.value.isHighlighted,
    (value) => {
      syncing = true;
      priorityBooking.value = value ?? false;
      nextTick(() => {
        syncing = false;
      });
    },
  );

  watch(priorityBooking, (newValue) => {
    if (syncing || !event.value.guid) return;
    event.value.isHighlighted = newValue;
    mutate({ guid: event.value.guid, patch: { ...event.value, isHighlighted: newValue } });
  });

  return { priorityBooking };
}
